import { AA_TEST_FR, NEW_SERP_FR, RELEASE_SWITCH_TOGGLE } from './names'
import { ExperimentName } from './types'

/**
 * List of experiments that are manually activated.
 *
 * Add the experiment name here if the experiment is something like AA test or
 * there is no `<Experiment name=... />` part
 */
export const MANUALLY_ACTIVATED: ExperimentName[] = [
  NEW_SERP_FR,
  AA_TEST_FR,
  RELEASE_SWITCH_TOGGLE
]
